<div class="bienvenida-container">
  <!-- ══════ Hero / saludo ══════ -->
  <div class="bienvenida-hero">
    <!-- Fecha · saludo · lema, el mismo bloque de texto que el inicio de
         fadminportal. Sin el icono de carita: el saludo con fecha y hora del
         día ya le da cuerpo al hero sin un adorno. -->
    <div class="bienvenida-hero-info">
      <p class="bienvenida-fecha">{{ fecha }}</p>
      <h1 class="bienvenida-hero-titulo">{{ saludo() }}</h1>
      <p class="bienvenida-lema">Tu espacio de Recursos Humanos.</p>
      <!-- ID y rol como una línea de identidad, no como dos píldoras. Eran dos
           pastillas del mismo blanco a 18% y 28% de opacidad: una diferencia que
           no se percibe y que no significaba nada, así que parecían el mismo
           elemento mal alineado.

           El ID va primero y con más peso porque es el dato duro —y resulta ser
           el ÚNICO lugar de la aplicación donde un empleado puede leer su
           MC####: en solicitar-vacaciones solo aparece dentro del selector de
           empleados, que ve Admin/RH—. El rol queda como contexto. -->
      <div class="bienvenida-hero-meta">
        @if (cargandoEmpleado()) {
          <nz-skeleton [nzActive]="true" [nzParagraph]="false" [nzTitle]="{ width: '180px' }" />
        } @else {
          @if (idInterno()) {
            <span class="bienvenida-id">{{ idInterno() }}</span>
          }
          @if (idInterno() && rol()) {
            <span class="bienvenida-sep">·</span>
          }
          @if (rol()) {
            <span class="bienvenida-rol">{{ rol() }}</span>
          }
        }
      </div>
      <!-- Sin el párrafo "Bienvenido al módulo de RH. Selecciona una de las
           opciones disponibles para continuar": saludaba por segunda vez tras el
           "¡Hola!" e instruía sobre algo evidente —abajo hay tarjetas grandes
           con flecha—. Ocupaba alto sin aportar. -->
    </div>

    <!-- Saldo propio. Ocupa el vacío de la derecha del hero en vez de sumar una
         sección, y es lo que convierte esta página en algo útil para quien solo
         tiene un acceso. -->
    @if (saldo(); as s) {
      <div class="bienvenida-saldo">
        <span class="bienvenida-saldo-val" [class.bienvenida-saldo-val--neg]="s.tieneSaldoNegativo">
          {{ s.diasDisponiblesTotal | number: '1.1-1' }}
        </span>
        <span class="bienvenida-saldo-lbl">
          {{ s.tieneSaldoNegativo ? 'días en negativo' : 'días disponibles' }}
        </span>
      </div>
    }
  </div>

  <!-- ══════ Accesos rápidos ══════ -->
  @if (accesos().length > 0) {
    <div class="acceso-grid">
      @for (acceso of accesos(); track acceso.key) {
        <button class="acceso-card" (click)="irA(acceso.ruta)" type="button">
          <div class="acceso-icon" [class]="'acceso-icon-' + acceso.color">
            <nz-icon [nzType]="acceso.icono" nzTheme="outline" />
          </div>
          <div class="acceso-info">
            <div class="acceso-titulo">{{ acceso.titulo }}</div>
            <div class="acceso-descripcion">{{ acceso.descripcion }}</div>
          </div>
          <div class="acceso-flecha">
            <nz-icon nzType="right" nzTheme="outline" />
          </div>
        </button>
      }
    </div>
  } @else {
    <intelishs-empty-state
      icon="info-circle"
      message="Por el momento no tienes accesos asignados. Si crees que es un error, contacta a Recursos Humanos."
    />
  }
</div>
